/**
 * 4-step tour for supervisors. Walks the take-review queue → audio
 * playback / A/B comparison → stem download flow. Selectors live on the
 * supervisor takes + stems pages; missing anchors fall back to a centered
 * tooltip so the tour still completes if launched from `/supervisor`.
 */
import type { TourStep } from '../TourStep'

export const SUPERVISOR_TOUR: readonly TourStep[] = [
  {
    id: 'supervisor-welcome',
    title: 'Welcome, Supervisor',
    body: "You'll spend most of your time in the take review queue. Four quick stops to show you how the day-to-day flows.",
  },
  {
    id: 'supervisor-take-queue',
    selector: '[data-tour="take-queue"]',
    title: 'Take review queue',
    body: 'Every take an actor records lands here. Approve, request a pickup, or archive — bulk actions are at the top.',
    placement: 'bottom',
  },
  {
    id: 'supervisor-ab-compare',
    selector: '[data-tour="ab-compare"]',
    title: 'Compare against reference',
    body: 'A/B the take against the AI guide voice, scrub the waveform, and inspect QC metrics before deciding.',
    placement: 'top',
  },
  {
    id: 'supervisor-stem-download',
    selector: '[data-tour="stem-download"]',
    title: 'Stems portal',
    body: 'When a character is fully approved you can render and download a per-character WAV stem and QC PDF. Download All grabs every ready stem in one ZIP.',
    placement: 'top',
  },
] as const
